import { z } from 'zod';

import { Locale, StringKey } from '../../lang/index';

export const passwordSchema = (transition: Record<StringKey, string>) =>
  z
    .string()
    .regex(/.*[a-z].*/, transition['AT_LEAST_ONE_LOWER_CASE_LETTER'])
    .regex(/.*[A-Z].*/, transition['AT_LEAST_ONE_UPPER_CASE_LETTER'])
    .regex(/.*[!@#$%^&*].*/i, transition['AT_LEAST_ONE_SPECIAL_CHAR'])
    .min(8, transition['AT_LEAST_EIGHT_CHARS']);

export const formSchema = (transition: Record<StringKey, string>) =>
  z
    .object({
      fullName: z
        .string()
        .regex(new RegExp('^[\\p{L}]+(?: [\\p{L}]+)*$', 'u'), 'Invalid full name'),
      password: passwordSchema(transition).or(z.literal('')).default(''),
      confirmPassword: z.string().or(z.literal('')).default(''),
      language: z.enum(Locale),
    })
    .refine((data) => data?.password === data?.confirmPassword, {
      message: transition['PASSWORDS_DONT_MATCH'],
      path: ['confirmPassword'],
    });

export type FormSchema = z.infer<ReturnType<typeof formSchema>>;
